import React, { useContext } from "react";
import { dataContext } from "../../context/DataContextProvider";
import "./Footer.css";
import "./ResponsiveFooter.css";

const Footer = () => {
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "footer"
  );

  const filetrKeyFooter = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };
  return (
    <div className="footer" id="contactUs">
      <div className="bg-container">
        <div className="content">
          <div className="left-section">
            <div className="icon-container">
              |{" "}
              <a
                href={`https://twitter.com/${filetrKeyFooter("twitter")?.map(
                  (item) => item.Value
                )}`}
                target="blank"
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href={`https://instagram.com/${filetrKeyFooter(
                  "instagram"
                )?.map((item) => item.Value)}`}
                target="blank"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a
                href={`https://aparat.com/${filetrKeyFooter("aparat")?.map(
                  (item) => item.Value
                )}`}
                target="blank"
              >
                <img src="/pic/aparat.png" alt="" />
              </a>
              <a
                href={`mailto: ${filetrKeyFooter("email")?.map(
                  (item) => item.Value
                )}`}
                target="blank"
              >
                <i className="fa fa-envelope"></i>
              </a>
            </div>
            <div className="email-container">
              <p className="m-0">
                | {filetrKeyFooter("footer-adress")?.map((item) => item.Value)}
              </p>
            </div>
            <div className="email-container">
              <p className="m-0">
                | {filetrKeyFooter("footer-phone")?.map((item) => item.Value)}
              </p>
            </div>
          </div>
          <div className="right-section">
            <p>
              {filetrKeyFooter("footer-copyright")?.map((item) => item.Value)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
